<td>{{storage.location}}</td>

<td style="width: 75px">{{storage.date_received}}</td>

<td style="width: 70px" class="align-right">
  <span class="label" [ngClass]="{'label-info': konsiNow, 'label-default': !konsiNow}">
    {{storage.days_stored|money:0}}&nbsp;Tage
  </span>
</td>

<td class="align-right">{{storage.amount_intake|money}}</td>

@if (('material.order.show.transaction.links'|HasPerm)) {
  <td class="icon">
    @if ((!!storage.order_transaction_id)) {
      <a uiSref="a.material.order.intake"
        ngbTooltip="Zur Einbuchung in Bestellung springen"
        [uiParams]="{order_id: storage.order_id, marked_transaction_id: storage.order_transaction_id}">
        <i class="fa fa-map-marker"></i>
      </a>
    }
  </td>
}

<td>{{storage.charge}}</td>

@if (('material.order.price.check'|HasPerm)) {
  <td class="align-right" [ngClass]="{'bold': isVendorPrice}">
    @if ((priceSingle !== null)) {
      <div [ngbTooltip]="isVendorPrice ? 'Preis aus Preisliste' : null">
        {{priceSingle|money:2}}&nbsp;&euro;
      </div>
    }
  </td>
}

<!--konsi amount columns - only shown when konsi is set for article, editable only when konsi is still active-->
@if (konsiNow) {
  <td class="align-right">
    {{storage.amount_konsi|money}}
  </td>
}
@if (konsiNow) {
  <td class="align-right click icon" (click)="changeAmountModal(storage, true)">
    <i class="fa fa-pencil" style="margin-left: 5px;"></i>
  </td>
}

@if (storage.konsi && !konsiNow) {
  <td class="align-right">
    -
  </td>
}
@if (storage.konsi && !konsiNow) {
  <td class="align-right">
  </td>
}


<!--storage amount columns - only shown when konsi is set for article-->
@if (storage.konsi) {
  <td class="align-right">
    {{storage.amount_storage|money}}
  </td>
}
@if (storage.konsi) {
  <td class="align-right click icon" (click)="changeAmountModal(storage, false)">
    <i class="fa fa-pencil" style="margin-left: 5px;"></i>
  </td>
}

<!--total amount columns - always shown, editable only when konsi is inactive-->
<td class="align-right">
  {{storage.amount|money}}
</td>
@if (!storage.konsi) {
  <td class="align-right click icon" (click)="changeAmountModal(storage)">
    <i class="fa fa-pencil" style="margin-left: 5px;"></i>
  </td>
}

<td>{{variation.unit}}</td>

@if (('material.order.price.check'|HasPerm)) {
  <td class="align-right">
    @if ((priceTotal !== null)) {
      {{priceTotal|money:2}}&nbsp;&euro;
    }
  </td>
}

@if (hasExpiration) {
  <td>{{storage.date_expiration}}</td>
}
<td class="icon">
  <ev-file-button [url]="'/api/material/pdf/' + storage.id" [link]="true">
    <i class="fa fa-file-pdf-o" aria-hidden="true" title="Etiketten PDF öffnen"></i>
  </ev-file-button>
</td>

